export const AGRITRACE_DATA_SOURCE = 'agd/agritrace';

/**
 * Label for a plot with no usable geometry. AgriTrace saves plots before they
 * are mapped; for every other source a missing geometry means it failed to parse.
 */
export function missingGeometryLabelKey(
  dataSource: string | null | undefined
): string {
  return dataSource === AGRITRACE_DATA_SOURCE
    ? 'GEOJSON_TYPE.UNMAPPED'
    : 'GEOJSON_TYPE.INVALID_GEOMETRY';
}
